module.exports = "/images/chico-01.png?6d2ec571fd6e48acfd18917eaad34311";


//////////////////
// WEBPACK FOOTER
// ./resources/images/assets2020/chico-01.png
// module id = ZalJ
// module chunks = 0